export default {
  data() {
    return {
      columns: [
        {
          prop: "name",
          label: "Name",
          default: "No Name"
        },
        {
          prop: "email",
          label: "email",
          default: "No email"
        },
        {
          prop: "phone",
          label: "phone",
          default: "No phone"
        },
        {
          prop: "created_at",
          label: "created at",
          default: "No data"
        },
        {
          prop: "action",
          label: "Action",
          isAction: true
        }
      ],
      paginationMeta: {
        current_page: 1,
        last_page: 1,
        total: 0,
        per_page: 15
      },
      propsToSearch: ["name"],
      searchQuery: ""
    };
  }
};
